import * as React from "react";
import { GridColumn } from "../../grid/grid-column/grid-column.mjs";
class OfferCounterItem extends React.Component {
  constructor() {
    super(...arguments);
    this.getChild = (children) => /* @__PURE__ */ React.createElement("div", { className: "offer-counter__figure-inner" }, children);
  }
  BEM() {
    const classArray = ["offer-counter__item"];
    if (this.props.className) {
      classArray.push(this.props.className);
    }
    return classArray.join(" ");
  }
  render() {
    return /* @__PURE__ */ React.createElement(GridColumn, { width: this.props.width, className: this.BEM() }, /* @__PURE__ */ React.createElement("div", { className: "offer-counter__figure" }, this.props.children && this.getChild(this.props.children), /* @__PURE__ */ React.createElement("div", { className: "offer-counter__table" })));
  }
}
export {
  OfferCounterItem
};
